import { ExerciseCategoryDto } from '../../../../shared/dtos/exerciseCategory.dto';
import React, { FC, ReactElement } from 'react';
import Table from 'react-bootstrap/Table';
import i18next from 'i18next';
import { Button } from 'react-bootstrap';

type ExerciseCategoriesTableProps = {
  categories: ExerciseCategoryDto[];
  onClick?: (category: ExerciseCategoryDto) => void;
}

const ExerciseCategoriesTable: FC<ExerciseCategoriesTableProps> = ({ categories, onClick }: ExerciseCategoriesTableProps): ReactElement => {

  return (
    <Table striped bordered hover responsive className="h-75 overflow-auto">
      <thead>
        <tr>
          <th className="centered-td">{i18next.t('exerciseCategory.germanTitle')}</th>
          <th className="centered-td">{i18next.t('exerciseCategory.englishTitle')}</th>
          <th className="centered-td">{i18next.t('exerciseCategory.isActive')}</th>
          { onClick !== undefined && (<th></th>) }
        </tr>
      </thead>
      <tbody>
        {categories.map((category: ExerciseCategoryDto)=> (
          <tr key={category.id}>
            <td className="centered-td">{category.de}</td>
            <td className="centered-td">{category.en}</td>
            <td className="centered-td">{i18next.t(category.isActive ? 'exerciseCategory.active' : 'exerciseCategory.notActive')}</td>
            {onClick !== undefined && (
              <td className='centered-td'>
                <Button variant='dark' onClick={() => {onClick(category);}}>
                  { i18next.t('generic.edit')}
                </Button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ExerciseCategoriesTable;
